export default __webpack_public_path__ + "static/media/app-android.5f577410.png";